import type { StaticDocumentTag } from '@/services/api/hipaaPackageService';

export const StaticDocumentLabels: Record<StaticDocumentTag, string> = {
  client_id: "Client's Photo ID",
  attorney_relationship: 'Attorney Relationship Form',
  reproductive_rights: 'Reproductive Rights Attestation',
  texas_affidavit: 'Texas Affidavit',
};
